export default "__VITE_ASSET__DhGbsaas__"